<template>
  <ElButton
    type="success"
    @click="showForm = true"
  >
    PROMOTE TO COMPANY

    <ElDialog
      append-to-body
      title="Company Info"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <ElFormItem label="Name">
          <Organization
            ref="organization"
            class="width-100"
            :value.sync="profile.organization.name"
            :selected.sync="profile.organization"
            :vuelidate="$v.profile.organization.$touch"
          />
        </ElFormItem>

        <ElFormItem label="Business Activity">
          <Industry
            class="width-100"
            :value.sync="profile.businessActivity"
            :vuelidate="$v.profile.businessActivity.$touch"
          />
        </ElFormItem>

        <ElFormItem label="Size">
          <OrganizationSize
            class="width-100"
            :value.sync="profile.enterpriseSize"
            :vuelidate="$v.profile.enterpriseSize.$touch"
          />
        </ElFormItem>
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="$v.profile.$invalid"
          @click="validateCompanyData()"
        >
          Promote
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { GlobalEmitter } from '@/utils/GlobalEmitter'

export default {
  name: 'PromoteAccount',
  components: {
    Industry: () => import('@/components/FormElements/Industry/Industry'),
    Organization: () => import('@/components/FormElements/Organization/Organization'),
    OrganizationSize: () => import('@/components/FormElements/OrganizationSize/OrganizationSize')
  },
  mixins: [ validationMixin ],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      profile: {
        organization: {
          name: ''
        },
        businessActivity: null,
        enterpriseSize: null
      }
    }
  },
  validations: {
    profile: {
      organization: {
        hasName: function(val) {
          return required(val.name)
        }
      },
      businessActivity: {
        required
      },
      enterpriseSize: {
        required
      }
    }
  },
  methods: {
    validateCompanyData() {
      const taskQueue = [
        this.$refs.organization.validateOrCreateOrganization()
      ]

      return Promise.all(taskQueue).then(this.promoteToCompany)
    },

    promoteToCompany() {
      const data = {
        email: this.user.email,
        profile: this.profile
      }

      return axios.post('admin/user/promote', data)
        .then(res => {
          this.successNotification(res.data)

          this.$store.commit('filters/keyword', this.user.email)

          this.showForm = false
          GlobalEmitter.$emit('closePanel')

          this.$router.replace('recruiters')
        })
        .catch(axios.handleError)
    }
  }
}
</script>
